import { HttpClient } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UrlsConfig } from '../../../config/urls.config';
import { MatSnackBar } from '@angular/material/snack-bar';
import { PagesSnackErrorComponent, PagesSnackSuccessComponent, PagesSnackWarningComponent } from '../../../pages/snack/snack.component';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-first-connexion',
  templateUrl: './first-connexion.component.html',
  styleUrls: ['./first-connexion.component.scss']
})
export class FirstConnexionComponent implements OnInit {

  passwordInput = "";
  password2Input = "";
  shortPasswordError = false;
  strongPasswordError = false;
  samePasswordError = false;
  hide = true;
  returnUrl: string;
  hostname: string;

  changeError = false
  errorMessage = ""

  constructor(private httpClient: HttpClient,
    public dialogRef: MatDialogRef<FirstConnexionComponent>,
    // private snack: MatSnackBar, 
    private router: Router,
    private route: ActivatedRoute,
    @Inject(MAT_DIALOG_DATA) public data: any) {

  }

  sendNewPassword() {

    this.samePasswordError = false;
    if (this.passwordInput != this.password2Input) {
      this.samePasswordError = true;
    }

    this.shortPasswordError = false;
    if (this.passwordInput.length < 12) {
      this.shortPasswordError = true;
    }

    this.strongPasswordError = false;
    if (this.testStrongitude(this.passwordInput).includes(false)) {
      this.strongPasswordError = true;
    }

    if (this.samePasswordError || this.shortPasswordError || this.strongPasswordError) {
      return
    }

    const data = { password: this.passwordInput }

    this.changeError = false
    this.httpClient.post(UrlsConfig.API_ENDPOINT + 'firstconnexion/changepassword', data, { observe: "response" }).subscribe(r => {

      if (r.status == 200) {

        this.dialogRef.close({ data: true });

      } else {
        this.changeError = true
        this.errorMessage = r.body["message"]
      }
    }, e => {

      this.changeError = true
      this.errorMessage = e.error.message

    }

    );

  }

  testStrongitude(chaine) {
    const contientMinuscule = /[a-z]/.test(chaine);
    const contientMajuscule = /[A-Z]/.test(chaine);
    const contientChiffre = /\d/.test(chaine);
    const contientCaractereSpecial = /[^a-zA-Z0-9]/.test(chaine);

    return [contientMinuscule, contientMajuscule, contientChiffre, contientCaractereSpecial];
  }

  ngOnInit(): void {
    this.returnUrl =
      this.route.snapshot.queryParams['returnUrl'.toString()] || '/';
    this.hostname = window.location.hostname;
  }

}
